import {
  SHOPIFY_SALES_CHANNEL_ALL_SUCCESS,
  SHOPIFY_SALES_CHANNEL_ALL_LOADING,
  } from '../actions/SalesByChannelAllAction';
  
  const initialState = {
    SalesByChannelAllData: [],
    isAllLoading: true
  };
  
  const SalesByChannelAllReducer = (state = initialState, action = {}) => {
    switch (action.type) {
      case SHOPIFY_SALES_CHANNEL_ALL_SUCCESS:
        return { ...state, SalesByChannelAllData: action.data, isAllLoading: false };
      case SHOPIFY_SALES_CHANNEL_ALL_LOADING:
        return { ...state, isLoading: action.isAllLoading };
      default:
        return state;
    }
  };
  
  export default SalesByChannelAllReducer;
  